import React, { Fragment, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import s from './ComponentPositionModel.module.scss';
import { FormattedMessage, injectIntl } from 'react-intl';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import ComponentPositionModel from './ComponentPositionModel';

const ComponentPositionModelListTable = ({
  ComponentPositionsManager,
  modelCategoryComponentPositions,
  disableMode,
  ModelId,
  saveComponentPosition,
  setComponentPositionChange,
  DeleteAllowed,
  deleteComponentPosition,
  cancelHandler,
  IsModelCategoryOwner,
  paginatedData = [],
  intl
}) => {
  const editModelVariantContent = (
    <ComponentPositionModel
      ModelId={ModelId}
      saveComponentPosition={saveComponentPosition}
      ComponentPositionsManager={ComponentPositionsManager}
      modelCategoryComponentPositions={modelCategoryComponentPositions}
      setComponentPositionChange={setComponentPositionChange}
      cancelHandler={cancelHandler}
    />
  );

  useLayoutEffect(() => {
    if (disableMode) {
      const scrollPos = window.scrollY + window.innerHeight;
      window.scrollTo(0, scrollPos);
    }
  }, [disableMode]);

  const getStatusText = status => {
    if (status) {
      return 'True';
    } else {
      return 'False';
    }
  };


  return (
    <div className={s.wsTableContainer}>
      <Table variant className={s.wsTable}>
        <thead>
          <tr>
            <th>
              <FormattedMessage id="model.componentpositions.positionName" defaultMessage="Position" />
            </th>
            <th>
              <FormattedMessage id="model.componentpositions.positionDescription" defaultMessage="Description" />
            </th>
            <th>
              <FormattedMessage id="model.componentpositions.componentType" defaultMessage="Component Type" />
            </th>
            <th>
              <FormattedMessage id="model.componentpositions.state" defaultMessage="State" />
            </th>
            <th>
              <FormattedMessage id="model.componentpositions.feedback" defaultMessage="Feedback" />
            </th>
            <th>
              <FormattedMessage id="model.componentpositions.unitOfMeasure" defaultMessage="Unit of Measure" />
            </th>
            <th>
              <FormattedMessage id="model.componentpositions.active" defaultMessage="Active" />
            </th>
            {DeleteAllowed && IsModelCategoryOwner &&<th></th>}
          </tr>
        </thead>
        <tbody>
          {paginatedData.map(n => {
            return (
              <Fragment key={n.ModelComponentPositionLinkId}>
                <tr key={n.ModelComponentPositionLinkId} data-unittest="ComponentPositionsData">
                  <td>{n.Name}</td>
                  <td>{n.Description}</td>
                  <td>{n.ComponentType}</td>
                  <td>{getStatusText(n.NeedState)}</td>
                  <td>{getStatusText(n.NeedFeedback)}</td>
                  <td>{n.NeedUnitOfMeasure || '-'}</td>
                  <td>{getStatusText(n.IsActive)}</td>
                  {DeleteAllowed && IsModelCategoryOwner && (
                    <td className={s.btnCol}>
                      {DeleteAllowed && (
                        <Button
                          variant="outline-secondary"
                          className={s.removeButton}
                          href="#"
                          onClick={() =>
                            deleteComponentPosition({
                              ModelComponentPositionId: n.ModelComponentPositionId,
                              ModelComponentPositionLinkId: n.ModelComponentPositionLinkId
                            })
                          }
                          disabled={disableMode}
                          data-unittest="changeData"
                        >
                          <FormattedMessage id="modelVariant.remove" defaultMessage="Remove" />
                        </Button>
                      )}
                    </td>
                  )}
                </tr>
              </Fragment>
            );
          })}
        </tbody>
      </Table>
      <div>
        {ComponentPositionsManager.showAddEditScreen && editModelVariantContent}
      </div>

    </div>
  );
};



ComponentPositionModelListTable.propTypes = {
  saveComponentPosition: PropTypes.func.isRequired,
  ComponentPositionsManager: PropTypes.object.isRequired,
  setComponentPositionChange: PropTypes.func.isRequired,
  ComponentPositionsData: PropTypes.array,
  DeleteAllowed: PropTypes.bool,
  disableMode: PropTypes.bool
};

export default injectIntl(ComponentPositionModelListTable);
